import React, { useEffect, useState } from "react";
import { Paper, IconButton, Box, CircularProgress } from "@mui/material";
import { X } from "lucide-react";
import { getPredictionHistogramData } from "../utils/requests";
import { PredictionGraphProps } from "../types";

const HistogramPrediction: React.FC<PredictionGraphProps> = ({
  selectedModel,
  onClose,
}) => {
  const [chartImage, setChartImage] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);

useEffect(() => {
  if (!selectedModel) return;

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const imageUrl = await getPredictionHistogramData(selectedModel);

      const img = new Image();
      img.src = imageUrl;
      img.onload = () => {
        setChartImage(imageUrl); // Set only after it's fully loaded
        setIsLoading(false);
      };
      img.onerror = (err) => {
        console.error("Error loading image:", err);
        setIsLoading(false);
      };
    } catch (err) {
      console.error("Error fetching histogram data:", err);
      setIsLoading(false);
    }
  };

  fetchData();
}, [selectedModel]);

  return (
    <Paper
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 600,
        height: 400,
        zIndex: 9999,
        pointerEvents: "auto",
        p: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
      elevation={3}
    >
      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", top: 5, right: 8, zIndex: 10 }}
      >
        <X />
      </IconButton>

      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        {isLoading ? (
          <CircularProgress />
        ) : (
          <img
            src={chartImage}
            alt="Histogram"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        )}
      </Box>
    </Paper>
  );
};

export default HistogramPrediction;
